<template>
  <div>
    <validation-observer
      ref="refFormObserver"
      #default="{ handleSubmit }"
    >
      <b-modal
        id="send-message-modal"
        v-model="isVisible"
        :title="$t('customers.send-message.custom')"
        :ok-title="$t('shared.btn.send')"
        :ok-disabled="processing || !hasReceivers"
        :cancel-title="$t('shared.btn.cancel')"
        cancel-variant="outline-secondary"
        @show="handleShow"
        @hidden="handleHide"
        @ok.prevent="handleSubmit(submitCustomMessage)"
      >
        <form @submit.stop.prevent>
          <validation-provider
            #default="validationContext"
            :name="$t('customers.send-message.subject.label')"
            rules="required|max:50"
          >
            <b-form-group
              :label="$t('customers.send-message.subject.label')"
              label-for="custom-message-subject"
              :state="getValidationState(validationContext)"
            >
              <b-form-input
                id="custom-message-subject"
                v-model.trim="form.subject"
                type="text"
                autocomplete="off"
                maxlength="50"
                :placeholder="$t('customers.send-message.subject.placeholder')"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            :name="$t('customers.send-message.receiver.label')"
            :rules="receiverValidationRule"
          >
            <b-form-group
              :label="$t('customers.send-message.receiver.label')"
              label-for="custom-message-receiver"
              :state="getValidationState(validationContext)"
            >
              <template v-if="hasReceivers">
                <b-form-radio-group
                  id="custom-message-receiver"
                  v-model="form.receiverType"
                  :options="receiverOptions"
                  buttons
                  button-variant="outline-primary"
                />
              </template>
              <template v-else>
                <small class="text-muted">
                  {{ $t('customers.send-message.no-recipient') }}
                </small>
              </template>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            :name="$t('customers.send-message.content.label')"
            rules="required|min:20|max:2000"
          >
            <b-form-group
              :label="$t('customers.send-message.content.label')"
              label-for="custom-message-content"
              :state="getValidationState(validationContext)"
            >
              <div class="textarea-with-counter">
                <b-form-textarea
                  id="custom-message-content"
                  v-model.trim="form.content"
                  :placeholder="$t('customers.send-message.content.placeholder')"
                  rows="6"
                  maxlength="2000"
                  no-resize
                />
                <small class="textarea-counter">
                  {{ contentLength }} / 2000
                </small>
              </div>
              <small class="text-muted d-block mt-25">
                {{ $t('customers.send-message.signature-info') }}
              </small>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-form-checkbox v-model="form.bccSender">
            {{ $t('customers.send-message.send-copy') }}
          </b-form-checkbox>
        </form>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormInvalidFeedback,
  BFormRadioGroup,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import useSendMessageModal from './useSendMessageModal'

export default {
  name: 'SendMessageModal',
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormRadioGroup,
    BFormCheckbox,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    receivers: {
      type: Array,
      default: () => [],
    },
    customerId: {
      type: [Number, String],
      default: null,
    },
    defaultReceiverType: {
      type: String,
      default: null,
    },
  },
  setup(props, context) {
    return useSendMessageModal(props, context)
  },
}
</script>

<style lang="scss" scoped>
.textarea-with-counter {
  position: relative;
}

.textarea-counter {
  position: absolute;
  right: 0.75rem;
  bottom: 0.35rem;
  font-size: 0.75rem;
  color: #6e6b7b;
}
</style>
